import "./src/css/style.css";
import "./src/css/fonts/fonts.css"
// AOS
import "aos/dist/aos.css";